import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export async function createMeetingRecording(
  context: ApiContext,
  meetingId: string,
  file: File,
  getRefreshedContext?: () => Promise<ApiContext | null>
): Promise<{ message: string }> {
  const apiRoot = (process.env.NEXT_PUBLIC_API_URL || "http://localhost:3000/api/").replace("/api/", "")

  const { uploadFileDirectly } = await import("@/utils/direct-upload")

  const signedId = await uploadFileDirectly(file, apiRoot, context.token)

  // Get a fresh context after upload since tokens expire quickly and large uploads can take a while
  const freshContext = getRefreshedContext ? ((await getRefreshedContext()) ?? context) : context

  return apiContextFetch<{ message: string }>(freshContext, `meetings/${meetingId}/recordings`, {
    method: "POST",
    body: JSON.stringify({ recording: { original_media: signedId } }),
  })
}

export async function createMeetingRecordingFromSignedId(
  context: ApiContext,
  meetingId: string,
  signedId: string
): Promise<{ message: string }> {
  return apiContextFetch<{ message: string }>(context, `meetings/${meetingId}/recordings`, {
    method: "POST",
    body: JSON.stringify({ recording: { original_media: signedId } }),
  })
}
